import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {IosUserChannelService} from '../../_services/ios-user-channel.service';
import {DataTableDirective} from 'angular-datatables';

@Component({
  selector: 'app-ios-user-channel',
  templateUrl: './ios-user-channel.component.html',
  styleUrls: ['./ios-user-channel.component.css']
})
export class IosUserChannelComponent implements OnInit {
  searchWord: string;
  id: string;

  delayTimer: any;
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  //declare parameters object
  parameters: any = {};
  //declare callback object
  callback: any = {};

  constructor(
      private iosUserChannelService: IosUserChannelService) {
  }

  ngOnInit() {
    this.registerTable();
  }

  registerTable() {
    let self = this;
    this.dtOptions = {
      language: {
        emptyTable: "データが存在しません"
      },
      order: [[0, "desc"]],
      searching: false,
      lengthChange: false,
      serverSide: true,
      pageLength: 15,
      ajax: function (parameters, callback, settings) {
        parameters["search"]["value"] = self.searchWord || '';

        //assign parameters object
        self.parameters = parameters;

        //assign callback object
        self.callback = callback;

        self.iosUserChannelService.gets(parameters).subscribe(result => {
          console.log(result.data);
          callback({
            draw: parameters['draw'],
            data: result.data,
            recordsTotal: result.data.length,
            recordsFiltered: result.recordsTotal
          });
        });
      },
      columns: [
        {
          title: "メール",
          data: "email",
          name: "email",
          className: "text-justify"
        },

        {
          title: "チャネル名",
          data: "bot_name",
          name: "bot_id",
          className: "all text-justify"
        },

        {
          title: '',
          data: 'btn_is_active',
          width: '60px',
          className: 'all text-center',
          orderable: false
        },

        {
          title: "",
          data: function (d) {
              return `<button class="btn btn-sm btn-danger btn-cancel">活性化のキャンセル</button>`;
          },
          width: '60px',
          className: "all text-center",
          orderable: false
        }
      ],
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;

        $('.btn-active', row).bind('click', () => {
          self.openActive(data);
        });
        $('.btn-cancel', row).bind('click', () => {
          self.openCancel(data);
        });
        if (data['is_request_active'] == 2){
          $(row).css('background-color', '#3c8dbc');
        }
        return row;
      }
    };
  }

  onChange(event) {
    // this.pairId = event.target.value;
    this.rerenderDataTable();
  }

  valuechange(newValue) {
    this.searchWord = newValue;
    this.doSearch();
  }

  doSearch() {
    let self = this;
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(function () {
      self.rerenderDataTable();
    }, 600); // Will do the ajax stuff aft
  };

  onChangeMarkets(event) {
    //this.marketId = event.target.value;
    this.rerenderDataTable();
  }

  rerenderDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  loadCurrentPage() {
    //get parameters and retrive result of current page
    this.iosUserChannelService.gets(this.parameters).subscribe(result => {
      //use callback function
      this.callback({
        //retrive draw current
        draw: this.parameters['draw'],
        //retrive data of current page
        data: result.data,
        //retrive number records per page
        recordsTotal: result.data.length,
        //retrive total records
        recordsFiltered: result.recordsTotal
      });
    });
  }

  openActive(data) {
    this.iosUserChannelService.active(data).subscribe(data1 => {
      this.loadCurrentPage();
    }, error => {

    });
  }

  openCancel(data) {
    this.iosUserChannelService.disable(data).subscribe(data1 => {
      this.loadCurrentPage();
    }, error => {

    });
  }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/ios-user-channel/ios-user-channel.component.ts